import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface WatchedItem {
  id: number;
  title?: string;
  name?: string;
  poster_path?: string;
  vote_average?: number;
  type: "movie" | "tv";
}

interface WatchedState {
  items: WatchedItem[];
}

const initialState: WatchedState = {items: []};

const watchedSlice = createSlice({
  name: "watched",
  initialState,
  reducers: {
    addToWatched(state, action: PayloadAction<WatchedItem>) {
      if (!state.items.find((i) => i.id === action.payload.id)) {
        state.items.unshift(action.payload);
      }
    },
    removeFromWatched(state, action: PayloadAction<number>) {
      state.items = state.items.filter((i) => i.id !== action.payload);
    },
    clearWatched(state) {
      state.items = [];
    },
  },
});

export const {addToWatched, removeFromWatched, clearWatched} = watchedSlice.actions;
export default watchedSlice.reducer;
